import api from "./api";

export async function getAllGroups() {
    const res = await api.get("/group");
    return res.data;
}

export async function getOneGroup(groupId) {
    const res = await api.get(`/group/${groupId}`);
    return res.data;
}

export async function addGroup(group) {
    const res = await api.post("/group", { ...group });
    return res.data;
}

export async function editGroup({ groupId, group }) {
    const res = await api.patch(`/group/${groupId}`, { ...group });
    return res.data;
}

export async function deleteGroup(groupId) {
    const res = await api.delete(`/group/${groupId}`);
    return res.data;
}
